<script>
  import clickTracker from '../tracking/clickTracker.js';
  import ImageTile from './ImageTile.svelte';
  import ProductInformation from './ProductInformation.svelte';

  let {
    recommendation,
    index,
    tracking,
    featureIndex,
    additionalClickTracking,
    width,
    featuresState
  } = $props();

  const baseDetailViewUrl = recommendation.links?.['o:base-detail-view-url']?.href;
  const variationDetailViewUrl = recommendation.links?.['o:detail-view']?.href;
  const conditionalBaseDetailViewUrl = !baseDetailViewUrl ? {} : { href: baseDetailViewUrl };
  const linkElementTag = !baseDetailViewUrl ? 'span' : 'a';

  const onClickTrackingHandler = (recommendation) => {
    clickTracker(
      tracking,
      recommendation.tracking,
      featureIndex,
      additionalClickTracking,
      recommendation.additionalClickTracking,
      recommendation.meta
    );
  };
</script>

<td
  class="column"
  style:min-width={width}
  style:max-width={width}
  data-tracking-id={'data_tracking_' + index}
  data-tracking-feature-id={recommendation.tracking?.id}
  ><div class="reco_comparison__table__header_data">
    <oc-link-v2 base64-href={btoa(variationDetailViewUrl)}>
      <svelte:element
        this={linkElementTag}
        onclick={() => onClickTrackingHandler(recommendation)}
        {...conditionalBaseDetailViewUrl}
        data-testid="reco-anchor">
        <ImageTile
          image={recommendation.image}
          variationId={recommendation.id}
          deal={recommendation.deal}
          isVeryPopular={recommendation.veryPopular}
          {featuresState} />
      </svelte:element>
    </oc-link-v2>
    <ProductInformation
      variation={recommendation}
      pricing={recommendation.formattedPrice}
      minimumOrderValueEligible={recommendation.minimumOrderValueEligible}
      tableTracking={tracking} />
  </div></td>

<style>
  .reco_comparison__table__header_data {
    padding-top: var(--oc-semantic-spacing-100);
    padding-bottom: var(--oc-semantic-spacing-75);
  }

  .column {
    padding-left: var(--oc-semantic-spacing-100);
    padding-right: var(--oc-semantic-spacing-100);
    vertical-align: top;
  }
</style>
